// src/core/LeaderboardClient.js
import { ConvexHttpClient } from "convex/browser";
import { api } from "../../convex/_generated/api";

const CONVEX_URL = (process.env.CONVEX_URL || "").trim();
const client = CONVEX_URL ? new ConvexHttpClient(CONVEX_URL) : null;

class LeaderboardClient {
    /**
     * Submit a score.
     * @param {string} gameId - Game identifier
     * @param {string} playerName - Player name
     * @param {number} score - Score value
     * @returns {Promise<{rank: number, totalPlayers: number}>}
     */
    static async submit(gameId, playerName, score) {
        if (!client) {
            console.warn('[Leaderboard] Skipping submit: CONVEX_URL is not configured.');
            return null;
        }

        try {
            return await client.mutation(api.scores.submitScore, {
                game: gameId,
                name: playerName,
                score,
            });
        } catch (err) {
            console.warn('[Leaderboard] Submit failed:', err.message);
            return null;
        }
    }

    /**
     * Get top scores for a game.
     * @param {string} gameId - Game identifier
     * @param {number} limit - Max results (default 10)
     * @returns {Promise<Array<{name: string, score: number}>>}
     */
    static async getTopScores(gameId, limit = 10) {
        if (!client) {
            console.warn('[Leaderboard] Skipping fetch: CONVEX_URL is not configured.');
            return [];
        }

        try {
            return await client.query(api.scores.getLeaderboard, {
                game: gameId,
                limit,
            });
        } catch (err) {
            console.warn('[Leaderboard] Fetch failed:', err.message);
            return [];
        }
    }
}

export default LeaderboardClient;
